// Windsurf generated file
import React from 'react'
import { useFeatureFlags } from './use-feature-flags'

interface FeatureFlagEnabledProps {
  flag: string
  children: React.ReactNode
}

/**
 * Wrapper component that conditionally renders children based on a feature flag.
 *
 * @example
 * ```tsx
 * import { FeatureFlagEnabled } from '../shared/feature-flag-enabled'
 * import { FeatureFlags } from '../../api/feature-flags-api'
 *
 * function MyComponent() {
 *   return (
 *     <FeatureFlagEnabled flag={FeatureFlags.ENABLE_PROPOSAL_DESCRIPTIONS}>
 *       <ProposalDescriptions />
 *     </FeatureFlagEnabled>
 *   )
 * }
 * ```
 */
export function FeatureFlagEnabled({
  flag,
  children,
}: FeatureFlagEnabledProps) {
  const { flags } = useFeatureFlags()

  // Check if the flag is enabled
  const isEnabled = flags[flag as keyof typeof flags]

  if (!isEnabled) {
    return null
  }

  return <>{children}</>
}
